import { render, staticRenderFns } from "./ViewerSearch.vue?vue&type=template&id=704f4c8d&scoped=true"
import script from "./ViewerSearch.vue?vue&type=script&lang=js"
export * from "./ViewerSearch.vue?vue&type=script&lang=js"
import style0 from "./ViewerSearch.vue?vue&type=style&index=0&id=704f4c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f4c8d",
  null
  
)

export default component.exports